import FormField from './field.js';

export default class DealerInfo extends FormField {

    constructor(parent, el) {
        super(parent, el);
        this.data = {};
        this.url = el.dataset.url;
        this.location = el.dataset.dealerLocation;
        this.param = el.dataset.dealerParam;
        this.service = el.dataset.dealerService;
        this.name = this.input('name') 
        this.phone = this.input('phone');
        this.email = this.input('email');
        this.bind();
        this.populate();
    }

    bind() {
        window.addEventListener('hashchange', () => this.populate());
    }

    dealer(){
        const params = this.location === 'hash' ? new URLSearchParams(window.location.hash.split("?")[1] || "") : new URLSearchParams(location.search || "");
        return params.get(this.param);    
    }

    populate(){
        const dealer = this.dealer();
        if (!dealer) { return; }
        dealer === this.data?.uri ? this.set() : this.get(dealer);
    }   

    set() {
        if(this.data?.uri){
            const name = this.data?.name;
            const phone = this.data?.productServices?.find(ps => this.service ? ps.code === this.service : ps.telephoneNumber )?.telephoneNumber;
            const email = this.data?.productServices?.find(ps => this.service ? ps.code === this.service : ps.emailAddress )?.emailAddress;
            this.name.el.value = name || "";
            this.phone.el.value = phone || "";
            this.email.el.value = email || "";
        } else {
            this.reset();
        }
    }

    reset() {
        this.name.el.value = "";
        this.phone.el.value = "";
        this.email.el.value = "";
    }

    save(result) {
        this.data = result?.dealer;
    }
    
    get(dealer) {
        const data = new FormData();
        data.append('dealer', dealer);
        return fetch(this.url, { method: 'POST', body: data })
            .then((response) => response.json())
            .then((result) => this.save(result))
            .then(() => this.set())
            .catch(() => this.reset())
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_dealer_info');
    }
}